export default __webpack_public_path__ + "static/media/empty-cart.1a9cd6c3.png";